module.exports = __webpack_public_path__ + "img/510a.ccc42e3a.png";